module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7de28b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/FooterBar.vue
// module id = 649
// module chunks = 25